import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  selectChildThreads,
  selectShowLoadingModal,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import ModalWrapper, { ModalWrapperRef } from './ModalWrapper';
import { noop } from 'lodash';

export const LoadingModal = () => {
  const modalRef = useRef<ModalWrapperRef>(null);

  const parentThreads = useSelector(selectChildThreads);

  const showLoadingIndicator = useSelector(selectShowLoadingModal);

  useEffect(() => {
    if (showLoadingIndicator) {
      modalRef.current?.show({
        subscribe: () => {
          noop;
        },
      });
    } else {
      modalRef.current?.close();
    }
  }, [showLoadingIndicator]);

  if (modalRef.current !== null && !parentThreads) {
    return null;
  }

  return (
    <ModalWrapper
      ref={modalRef}
      title="Save Thread"
      content={
        <div>
          <ModalTextWrapper>
            <p>Persisting....</p>
          </ModalTextWrapper>
        </div>
      }
    />
  );
};

const ModalTextWrapper = styled.div`
  text-align: left;
  padding: 0 24px 24px 24px;
`;
